// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__LeOKu","tab":"ProcedureTabs_tab__3w0yc"};